import Phaser, {
    Display
} from 'phaser'

import Video from './Video'
import OverlayGraphics from './OverlayGraphics'

//*** VARIABLES ***/
let utils;
let location;
let gameScale;
let w;
let h;
var clickedImg;
let isLocation;
let padding;
let topPadding;
let numPages;
let domText;
let textY;
let textX;
let domTitle;
let special;
let xmlLoader;
let _this;
let video;
let isLandscape;
let overlayGraphics;
let videoAdjustY = 60;

export default class Overlay extends Phaser.Scene {
    constructor(scene = 'overlay') {
        super(scene)
    }

    init(data) {
        this.cameras.main.setBackgroundColor('rgba(0, 0, 0, 0.8)');
        //which overlay is it?
        location = data.location;
        //what image was clicked to get us here?
        clickedImg = data.img;
        _this = this;
        //Are we coming from the world scene or somewhere else?
        isLocation = data.isLocation;
    }
    preload() {}

    create() {

        xmlLoader = this.scene.get('xmlLoader');
        gameScale = this.registry.get('scaleIt');
        //initiate/restart variables
        special = "";
        padding = this.registry.get('padding');
        utils = this.scene.get('utils');
        w = this.game.canvas.width;
        h = this.game.canvas.height
        topPadding = 104 * gameScale;

        //The home button acts as a close button for the locations that launch from the world
        //If we are coming direct from the world scene the xml hasn't been loaded yet
        //If this overlay is it's own location (ie, plants) then it needs to load xml

        if (isLocation) {
            xmlLoader.loadThis({
                id: location + 'XML',
                path: '././assets/xml/' + location + '.xml',
                callback: this.parseXML,
                parent: this,
                section: location
            });
            //otherwise use the xmlLoader scene that has been passed in
        } else {
            xmlLoader.setSection(location);
            this.parseXML();
        }

        this.events.on('shutdown', this.paused, this);
        this.events.on('boot', this.active, this);
    }

    paused() {
        xmlLoader.events.shutdown();
    }
    active() {

        xmlLoader.events.on('changeSpeech', _this.updatePage, _this);
        xmlLoader.events.on('endOfSpeech', _this.disableButton.bind(_this, overlayGraphics.getNext()), _this);
        xmlLoader.events.on('startOfSpeech', _this.disableButton.bind(_this, overlayGraphics.getBack()), _this);

        xmlLoader.setSection(location);
        numPages = xmlLoader.getSpeechLength();
        _this.updatePage();
        _this.disableButton(overlayGraphics.getBack());
    }

    //Called at start and whenever next/back button is called
    updatePage() {


        if (this.scene.isSleeping('overlay')) return;

        //Check for if xml marks this as a landscape layout
        //In future add code to switch between speech layouts vs section
        //isLandscape = false;
        //if (xmlLoader.getSectionAttribute('orientation') == 'landscape') isLandscape = true;
        //isLandscape = this.checkLandscape();
        //reset buttons
        this.enableButton(overlayGraphics.getNext());
        this.enableButton(overlayGraphics.getBack());

        //If the last page had something special happening clear it out
        if (special) this.clearSpecial();



        this.updateTextPosition();
        //update it so buttons can adjust 
        //domText.updateSize();
        //now check for special circumstances:
        special = xmlLoader.getSpeech().getAttribute('special');
        if (special) {
            this.handleSpecial();
        }

    }


    handleSpecial() {
        switch (special) {
            case 'video':
                //replace the regular image with a video image
                overlayGraphics.getImage().visible = false;

                //Has the video scene already been added?
                if (this.scene.get('video')) {

                    this.scene.resume('video');
                } else {
                    //the xml has the path to the video file
                    let url = xmlLoader.getAttribute('path');

                    video = this.scene.add('video', Video, true, {
                        url: url,
                        parent: this,
                        x: padding * 2,
                        y: topPadding - padding * 1.5
                    });
                }

                break;

            case 'image':
                overlayGraphics.setImage({
                    id: xmlLoader.getAttribute('id'),
                    x: xmlLoader.getAttribute('x'),
                    y: xmlLoader.getAttribute('y'),

                })

                break;

            default:
                break;
        }

    }
    clearSpecial() {
        switch (special) {
            case 'video':
                this.scene.pause('video');
                overlayGraphics.getImage().visible = true;
        }
    }

    updateButtons(coords) {
        if (numPages <= 1) return;

        //  let overlayGraphics = this.scene.get('overlayGraphics');
        let back = overlayGraphics.getBack();
        back.x = coords[0] + back.width / 2;
        back.y = coords[1] + back.height / 2;

        let next = overlayGraphics.getNext();
        next.x = back.x + next.width + padding;
        next.y = coords[1] + next.height / 2 + 13 * gameScale;

        next.setVisible(true);
        back.setVisible(true);
    }

    createDomText(data) {
        let thisOne = data.thisOne;
        let fontSize = data.fontSize || 22;
        let color = data.color || '#ffffff';
        let text = data.text || '';
        let lineHeight = data.lineHeight || 100;
        let css = data.css;
        let textX = data.x || 0;
        let textY = data.y || 0;

        //remove the last one (reusing the same dom proved buggy on mobile)
        if (thisOne) thisOne.destroy();

        thisOne = this.add.dom(textX, textY).createFromHTML("<span class = " + css + ">" + text + "</>");
        thisOne.setOrigin(0, 0);

        let textStyle = thisOne.node.style;
        textStyle.fontSize = fontSize * gameScale + 'px';
        textStyle.width = data.textWidth + 'px';
        textStyle.color = color;
        textStyle.lineHeight = lineHeight + '%';

        thisOne.updateSize();

        return thisOne;
    }

    calculateTextPosition(data) {
        //Hold the width of the text calculations
        let textWidth;
        //what is the standard image
        let img = overlayGraphics.getImage();
        //what was the original scale of this image?
        let imgScale = overlayGraphics.getImageScale();
        //Either calculate the width based on the standard image or look for special parameter
        let imgWidth = data.imgWidth || img.width * imgScale;
        let imgHeight = data.imgHeight || img.height * imgScale;

        //isLandscape = false;
        //if (xmlLoader.getSectionAttribute('orientation') == 'landscape') isLandscape = true;
        if (this.checkLandscape()) {
            textWidth = w - padding * 6;
            textX = padding * 3;
            textY = topPadding + imgHeight + padding;
        } else {
            textWidth = w - imgWidth - padding * 6;
            textX = imgWidth + padding * 4;
            textY = topPadding;
        }

        //Override the calculations if specific settings were passed
        textX = data.x || textX;
        textY = data.y || textY;
        textWidth = data.width || textWidth;
        return ({
            textWidth: textWidth,
            textX: textX,
            textY: textY
        })
    }

    updateTextPosition(data = {}) {
        //separate function to calculate x,y,width
        let settings = this.calculateTextPosition(data);

        //Find out if this speech has a new title or use the section tit;e
        let newTitle = xmlLoader.getTagText('title');

        if (!newTitle) {
            newTitle = xmlLoader.getTitle();
        }
        //create the title dom element
        domTitle = this.createDomText({
            thisOne: domTitle,
            text: newTitle,
            fontSize: 33,
            color: '#F7EAAD',
            css: data.class || "",
            x: settings.textX,
            y: settings.textY,
            textWidth: settings.textWidth
        });
        this.domTitle = domTitle;

        //Create the text element
        //get the new text
        let currentText = xmlLoader.getLanguage();
        //Some circumstances the text has highlighting
        let keyword = this.registry.values.keyword
        //If there is a keyword AND it's for this location
        if (keyword) {
            if (keyword[0] == location) currentText = utils.highlightText(currentText);
        }
        let textY = domTitle.y + domTitle.height + padding;
        domText = this.createDomText({
            thisOne: domText,
            text: currentText,
            lineHeight: 120,
            css: data.class || "",
            x: settings.textX,
            y: textY,
            textWidth: settings.textWidth
        });
        this.domText = domText;

        //updateButtons
        this.updateButtons([settings.textX, (textY + domText.height)]);
    }
    /*
        createText() {
            this.updateTextPosition();
           
            this.active();
        }*/

    disableButton(obj) {
        if (numPages == 1) return;
        obj.disableInteractive();
        obj.alpha = 0.5;
    }

    enableButton(obj) {

        if (numPages == 1) return;
        obj.setInteractive();
        obj.alpha = 1;
    }

    checkLandscape() {
        isLandscape = false;
        //If the section is set to landscape then turn it true
        let test = xmlLoader.getAttribute('orientation', xmlLoader.getSection());

        if (test == "landscape") isLandscape = true;
        //Getting more specific is there a setting for the speech tag?
        test = xmlLoader.getAttribute('orientation')

        if (test == "landscape") {
            isLandscape = true;
        } else if (test == "portrait") {
            isLandscape = false;
        }


        return isLandscape;
    }
    parseXML() {

        numPages = xmlLoader.getSpeechLength();

        let settings = {
            xmlLoader: xmlLoader,
            parent: _this,
            img: clickedImg,
            isLocation: isLocation
        };

        //      isLandscape =  this.checkLandscape();

        overlayGraphics = _this.scene.get('overlayGraphics');
        if (overlayGraphics) {
            _this.scene.launch('overlayGraphics', settings);
        } else {
            _this.scene.add('overlayGraphics', OverlayGraphics, true, settings);
        }


        //xmlLoader.setSection('intro');
        let section = xmlLoader.getSection();
        let intro = xmlLoader.getTag('intro', section);

        if (intro.length > 0) {
            _this.setupGuide();
        }


    }






    setupGuide() {
        let guide = this.scene.get('guide');
        guide.setupGuide(this.guideSettings());
    }

    //Unique guide settings for this scene
    guideSettings() {


        return ({
            id: 'guideProfile',
            //When the guide is ready showSpeech bubble
            callback: this.showSpeech
        });

    }

    showSpeech() {
        let section = xmlLoader.getSection();
        let tag = xmlLoader.getTag('intro', section);
        let guide = _this.scene.get('guide');

        // xmlLoader.setSection('')

        guide.speechBubble({
            callback: _this.closeGuide,
            text: xmlLoader.getLanguage(tag[0]),
            width: 285,
            context: _this
        });
    }

    closeGuide() {
        let guide = _this.scene.get('guide');
        guide.removeBubble();

        //Give the bubble a second and then hide the guide

        let nav = _this.scene.get('navigate');
        _this.scene.get(nav.getLocation()).setupGuide(false);
        _this.scene.sendToBack('guide');
    }
    setOverlayGraphics(val) {
        overlayGraphics = val;
    }

    getSpecial() {
        return special;
    }

    shareVariables() {
        //this.domTitle = domTitle;
        //this.domText = domText;
        this.overlayGraphics = overlayGraphics;
        this.xmlLoader = xmlLoader;
    }




}